import React from 'react'
import { BottomModalBase } from './BottomModal'
import { Profile } from '@hooks'
import { QRCodeContent } from '../../screens/menu/qrCode/QRCodeContent'

type ShareProfileModalProps = {
  isVisible: boolean
  setIsVisible: React.Dispatch<React.SetStateAction<boolean>>
  profile?: Profile
}

export const ShareProfileModal = ({
  isVisible,
  setIsVisible,
}: ShareProfileModalProps): React.ReactElement => {
  return (
    <BottomModalBase isVisible={isVisible} setIsVisible={setIsVisible} hasCloseButton>
        <QRCodeContent />
    </BottomModalBase>
  )
}